"use client";

import Image from "next/image";
import { ArrowRight, X } from "lucide-react";
import { useTranslations } from "next-intl";
import { useDismissibleHomeBanner } from "./hooks/useDismissibleHomeBanner";

const TOP_BANNER_COOKIE = "top_banner_dismissed";

const TopBanner = () => {
  const { isVisible, dismiss: handleClose } =
    useDismissibleHomeBanner(TOP_BANNER_COOKIE);
  const t = useTranslations("HomeTopBanner");

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div className="relative rounded-[4.935px] [opacity:0.71] [background:linear-gradient(156deg,rgba(255,255,255,0.00)_32.4%,#D1F4FD_65.94%),#FFF] min-h-20 lg:hidden dark:[opacity:1] dark:[background:linear-gradient(156deg,rgba(255,255,255,0.00)_32.4%,rgba(66,230,255,0.12)_65.94%),#0B1120]">
        <div className="container mx-auto">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="w-20 h-20 mt-1">
                <Image
                  src="/assets/v2/images/Banner/tokens.png"
                  alt={t("tokensAlt")}
                  className="max-h-full"
                  width={500}
                  height={500}
                  quality={100}
                />
              </div>
              <div>
                <p className="font-inter font-semibold text-xs mb-0">
                  <span className="text-sleap-blue-100 mb-0">
                    {t("oneToken")}
                  </span>
                </p>
                <p className="font-inter font-semibold text-xs text-sleap-gray-900 dark:text-lightwhite mb-0">
                  {t("fullEcosystem")}
                </p>

                <a
                  href="https://www.staynex.vip/stay-token?utm_source=sleap&utm_medium=banner&utm_campaign=staynex_ecosystem&utm_content=top_token_banner"
                  target="_blank"
                  className="dark:text-lightwhite text-sleap-gray-900 font-medium text-[10px] mt-2 inline-flex items-center gap-x-2 border-b border-current leading-none"
                >
                  {t("discoverMore")}{" "}
                  <ArrowRight
                    className="dark:text-lightwhite text-sleap-gray-900"
                    size={10}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={handleClose}
          aria-label={t("closeBanner")}
          className="absolute right-3 top-3 cursor-pointer text-black dark:text-lightwhite px-0"
        >
          <X size={16} />
        </button>
      </div>

      <div className="relative hidden rounded-[11px] [background:linear-gradient(114deg,rgba(255,255,255,0.00)_46.91%,#D1F4FD_69.9%),#FFF] min-h-20 lg:block dark:[background:linear-gradient(114deg,rgba(255,255,255,0.00)_46.91%,rgba(66,230,255,0.12)_69.9%),#0B1120] dark:border dark:border-[rgba(66,230,255,0.25)]">
        <div className="container mx-auto">
          <div className="flex items-center justify-center gap-20">
            <div className="flex gap-x-6 items-center">
              <div className="h-20 w-[88px]">
                <Image
                  src="/assets/v2/images/Banner/tokens.png"
                  alt={t("tokensAlt")}
                  className="max-h-full"
                  width={500}
                  height={500}
                  quality={100}
                />
              </div>
              <div>
                <p className="font-inter font-semibold text-lg mb-0">
                  <span className="text-sleap-blue-100 mb-0">
                    {t("oneToken")}
                  </span>
                </p>
                <p className="font-inter font-semibold text-lg text-sleap-gray-900 dark:text-lightwhite mb-0">
                  {t("fullEcosystem")}
                </p>
              </div>
            </div>
            <div>
              <p className="mb-0 whitespace-pre-line text-sm font-inter text-sleap-gray-900 dark:text-lightwhite">
                {t("unlockBenefits")}
              </p>
            </div>
            <div className="flex items-center justify-center">
              <a
                href="https://www.staynex.vip/stay-token?utm_source=sleap&utm_medium=banner&utm_campaign=staynex_ecosystem&utm_content=top_token_banner"
                target="_blank"
                className="rounded-md bg-[linear-gradient(135deg,_#42E6FF_0%,_#8B5EF7_100%)] text-white px-4 py-2 text-xs font-normal transition-opacity hover:opacity-90 font-inter"
              >
                {t("discoverMore")}{" "}
              </a>
              <div className="ms-4">
                <Image
                  src="/assets/v2/images/Banner/token.png"
                  alt={t("tokensAlt")}
                  className="max-h-full h-20 w-44"
                  width={500}
                  height={500}
                  quality={100}
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleClose}
          aria-label={t("closeBanner")}
          className="absolute right-4 top-4 cursor-pointer text-black dark:text-lightwhite px-0"
        >
          <X size={16} />
        </button>
      </div>
    </>
  );
};

export default TopBanner;
